import React, { useCallback, useEffect, useState } from "react";

import { CiSearch } from "react-icons/ci";

import profile from "../../assets/images/Abdulluah-Talent.png";

import dashboard_user from "../../assets/images/dashboard-user.png";
import dashboard_users from "../../assets/images/dashboard-users.png";
import person_profile from "../../assets/images/person-profile.png";
import { Button, Col, Row, Table } from "react-bootstrap";
import dollar from "../../assets/images/dollar.png";
import { toast } from "react-toastify";
import ApiService from "../../services/ApiService";
import { ChevronLeft, ChevronRight, User } from "lucide-react";
import Image from "../../components/Image";
import Paginator from "../../components/Paginator";
import Lottie from "lottie-react";
import NoDataAnimation from "../../assets/animations/No Result Green theme.json"
import debounce from "lodash.debounce";
import { useTranslation } from "react-i18next";

const Dashboard = () => {
  const [showDropdown, setShowDropdown] = useState(false);
      const { t, i18n } = useTranslation();
      const isRTL = i18n.language === 'ar';
  const statusStyles = {
    Accepted: { bg: "#D3FDEA", color: "#5F8D73" },
    Pending: { bg: "#FEE8D3", color: "#D07B1F" },
    Rejected: { bg: "#FDE3E3", color: "#D15F5F" },
    Hired: { bg: "#6F42C1", color: "white" },
    Completed: { bg: "#4285F4", color: "white" },
  };

  const hireProjects = [
    {
      logo: person_profile,
      company: "World Studios",
      job: "Casting Actor",
      start: "14 April",
      end: "20 April",
      status: "Active",
      project: "D4 Movie",
      amount: "3000 AED",
    },
    {
      logo: person_profile,
      company: "River Picture",
      job: "Casting Actor",
      start: "14 April",
      end: "20 April",
      status: "Active",
      project: "D4 Movie",
      amount: "5000 AED",
    },
    {
      logo: person_profile,
      company: "Marvel Studios",
      job: "Casting Actor",
      start: "14 April",
      end: "20 April",
      status: "Active",
      project: "D4 Movie",
      amount: "3500 AED",
    },
  ];


  const [dashboardData, setDashboardData] = useState([]);
  const [dashboardCountData, setDashboardCountData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [search, setSearch] = useState("")
  const [pagination, setPagination] = useState({
    total_pages: 1,
    current_page: 1,
  });

  useEffect(() => {
    fetchDashboardData(1, "");
  }, []);

  console.log("Dashboard Data:", dashboardData);

  const fetchDashboardData = async (page = 1, searchValue = "") => {
    try {
      setIsLoading(true);
      const res = await ApiService.request({
        method: "GET",
        url: `company/getDashboard?page=${page}&search=${searchValue}`,
      });

      const data = res.data;
      if (data.status) {
        setDashboardData(data?.data?.active_hires);
        setDashboardCountData(data?.data?.stats);
        setPagination(data?.data?.pagination ? data?.data?.pagination : 1);
      } else {
        toast.error(data.message);
      }
    } catch (err) {
      console.error("Fetch Job Error:", err);
      toast.error("Failed to fetch jobs.");
    } finally {
      setIsLoading(false);
    }
  };
  const debouncedSearch = useCallback(
    debounce((query) => {
      fetchDashboardData(1, query);
    }, 500), // wait 500ms after typing stops
    []
  );
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearch(value);
    debouncedSearch(value);
  };
  const handlePageChange = (page) => {
    if (
      page !== pagination.current_page &&
      page >= 1 &&
      page <= pagination.total_pages
    ) {
      fetchDashboardData(page);
    }
  };

  const { current_page, total_pages } = pagination;

  // Generate page numbers (for large datasets show 1,2,3,...,last)
  const getPages = () => {
    const pages = [];

    if (total_pages <= 5) {
      for (let i = 1; i <= total_pages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);
      if (current_page > 3) {
        pages.push("...");
      }
      for (
        let i = Math.max(2, current_page - 1);
        i <= Math.min(total_pages - 1, current_page + 1);
        i++
      ) {
        pages.push(i);
      }
      if (current_page < total_pages - 2) {
        pages.push("...");
      }
      pages.push(total_pages);
    }

    return pages;
  };

  const pages = getPages();

  function formatSingleDate(isoDate) {
    const date = new Date(isoDate);
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "short" }); // or "long" for full month name
    return `${day} ${month}`;
  }

  return (
    <div
      className="inter-font "
      style={
        {
          // height: "100vh",
          overflowY: "scroll",
          overflowX: "hidden",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
          width:""
        }
      }
    >
      {/* Main Content */}
      <div className="inter-font flex-grow-1 md:px-5 main-bg inp-login">
        {/* <Navbar /> */}
        <div className="inter-font position-relative mb-3">
          {isRTL ?  <CiSearch
            className="inter-font position-absolute"
            style={{
              right: "12px",
              top: "50%",
              transform: "translateY(-50%) scaleX(-1)",
              pointerEvents: "none",
            }}
            size={20}
          /> : null }

          <input
            type="text"
            placeholder={t("c_ff_text65")}
            value={search}
          onChange={handleSearchChange}
            className={`inter-font w-100 p-2 rounded-3 ${isRTL ? 'pe-5' : 'ps-5'} inter-font`}
            style={{ paddingLeft: "2.5rem", border: "none", fontSize: "14px" }}
          />
          {isRTL ? null : <CiSearch
            className="inter-font position-absolute"
            style={{
              left: "12px",
              top: "50%",
              transform: "translateY(-50%)",
              pointerEvents: "none",
            }}
            size={20}
          />}
        </div>
        {/* Stats Cards */}
      <div className="inter-font row my-5" dir={isRTL ? "rtl" : "ltr"}>
  <div className="inter-font col-md-4">
    <h4 className="inter-font inter-font card-heading mb-4" style={{ textAlign: isRTL ? 'right' : 'left' }}>
      {t("c_d_text1")}
    </h4>
    <div
      className="inter-font card border-0 shadow-sm p-3 rounded-3"
      style={{
        background: "rgba(231, 142, 123, 1)",
        color: "white",
      }}
    >
      <div className="inter-font d-flex align-items-center gap-3" style={{ flexDirection: isRTL ? 'row-reverse' : 'row' }}>
        <div
          className="inter-font rounded-circle bg-white d-flex align-items-center justify-content-center"
          style={{
            width: "50px",
            height: "50px",
            minWidth: "50px",
          }}
        >
          <img
            src={dashboard_user}
            alt="Dashboard User"
            style={{
              width: "30px",
              height: "30px",
              objectFit: "contain",
            }}
          />
        </div>
        <div style={{ textAlign: isRTL ? 'right' : 'left' }}>
          <h6
            className="inter-font mb-1 inter-font"
            style={{ fontSize: "15px", fontWeight: 500 }}
          >
            {t("new_text_21")}
          </h6>
          <h2
            className="inter-font fw-bold mb-0 inter-font"
            style={{ fontSize: "22px", direction: 'ltr' }}
          >
            {dashboardCountData?.active_hires || 0}
          </h2>
        </div>
      </div>
    </div>
  </div>
  
  <div className="inter-font col-md-4">
    <h4 className="inter-font inter-font card-heading mb-4" style={{ textAlign: isRTL ? 'right' : 'left' }}>
      {t("c_d_text1")}
    </h4>
    <div
      className="inter-font card border-0 shadow-sm p-3 rounded-3"
      style={{
        background: "rgba(205, 73, 109, 1)",
        color: "white",
      }}
    >
      <div className="inter-font d-flex align-items-center gap-3" style={{ flexDirection: isRTL ? 'row-reverse' : 'row' }}>
        <div
          className="inter-font rounded-circle bg-white d-flex align-items-center justify-content-center"
          style={{
            width: "50px",
            height: "50px",
            minWidth: "50px",
          }}
        >
          <img
            src={dashboard_users}
            alt="Dashboard User"
            style={{
              width: "30px",
              height: "30px",
              objectFit: "contain",
            }}
          />
        </div>
        <div style={{ textAlign: isRTL ? 'right' : 'left' }}>
          <h6
            className="inter-font mb-1 inter-font"
            style={{ fontSize: "15px", fontWeight: 500 }}
          >
            {t("new_text_22")}
          </h6>
          <h2
            className="inter-font fw-bold mb-0 inter-font"
            style={{ fontSize: "22px", direction: 'ltr' }}
          >
            {dashboardCountData?.total_hires || 0}
          </h2>
        </div>
      </div>
    </div>
  </div>
  
  <div className="inter-font col-md-4">
    <h4 className="inter-font inter-font card-heading mb-4" style={{ textAlign: isRTL ? 'right' : 'left' }}>
      {t("c_d_text2")}
    </h4>
    <div
      className="inter-font card border-0 shadow-sm p-3 rounded-3"
      style={{
        background: "rgba(123, 110, 67, 1)",
        color: "white",
      }}
    >
      <div className="inter-font d-flex align-items-center gap-3" style={{ flexDirection: isRTL ? 'row-reverse' : 'row' }}>
        <div
          className="inter-font rounded-circle bg-white d-flex align-items-center justify-content-center"
          style={{
            width: "50px",
            height: "50px",
            minWidth: "50px",
          }}
        >
          <img
            src={dollar}
            alt="Dashboard User"
            style={{
              width: "30px",
              height: "30px",
              objectFit: "contain",
            }}
          />
        </div>
        <div style={{ textAlign: isRTL ? 'right' : 'left' }}>
          <h6
            className="inter-font mb-1 inter-font"
            style={{ fontSize: "15px", fontWeight: 500 }}
          >
            {t("new_text_23")}
          </h6>
          <h2
            className="inter-font fw-bold mb-0 inter-font"
            style={{ fontSize: "22px", direction: 'ltr' }}
          >
            {dashboardCountData?.total_spendings || 0} AED
          </h2>
        </div>
      </div>
    </div>
  </div>
</div>

        {/* Current Hires Section */}
        <div>
          <h5 className="inter-font mb-4 inter-font" style={{ fontSize: "16px" }}>
            {t("c_d_text3")}
          </h5>
          <div
            className="inter-font bg-white rounded-3 p-4 shadow"
            style={{ height: "auto", overflow: "auto" }}
          >
            <table className="inter-font table align-middle mb-0" style={{minWidth:"786px"}}>
              <thead>
                <tr>
                  <th scope="col">{t("c_d_table_c1")}</th>
                  <th scope="col">{t("c_d_table_c2")}</th>
                  <th scope="col">{t("t_d_text80")}</th>
                  <th scope="col">{t("c_d_table_c4")}</th>
                  <th scope="col">{t("c_d_table_c5")}</th>
                  <th scope="col">{t("c_d_table_c6")}</th>
                  <th scope="col">{t("c_t_text1")}</th>
                  <th scope="col">{t("c_d_table_c8")}</th>
                </tr>
              </thead>
              <tbody>

                {isLoading ? (
                  <tr className="border-0">
                  <td colSpan="8" className="p-0 border-0">
                    <div className="d-flex justify-content-center align-items-center py-5">
                      <p className="mb-0 text-muted">Loading…</p>
                    </div>
                  </td>
                </tr>
                ) : dashboardData?.length === 0 ? (
                  <tr className="border-0">
                  <td colSpan="8" className="p-0 border-0">
                  <div className="d-flex flex-column align-items-center py-5">
                  <div style={{ width: 200 }}>
                    <Lottie animationData={NoDataAnimation} loop={true} />
                  </div>
                </div>

                  </td>
                </tr>
                ) : (
                  dashboardData.map((talent, index) => {
                    return (
                     <tr key={index}>
  <td>
    <div className="inter-font d-flex align-items-center gap-3">
      <Image
        src={talent?.talent_id?.picture}
        alt="logo"
        className="rounded-circle"
        style={{
          width: "52px",
          height: "52px",
          objectFit: "cover",
        }}
      />
    </div>
  </td>
  <td style={{ direction: "ltr", unicodeBidi: "plaintext" }}>
    <div className="inter-font d-flex align-items-center gap-3">
      <span className="inter-font inter-font" style={{ color: "#959595" }}>
        {talent?.talent_id?.first_name} {talent?.talent_id?.last_name}
      </span>
    </div>
  </td>
  <td style={{ color: "#959595", direction: "ltr", unicodeBidi: "plaintext" }}>
    {talent?.job_type}
  </td>
  <td style={{ color: "#959595", direction: "ltr", unicodeBidi: "plaintext" }}>
    {formatSingleDate(talent?.start_date)}
  </td>
  <td style={{ color: "#959595", direction: "ltr", unicodeBidi: "plaintext" }}>
    {formatSingleDate(talent.end_date)}
  </td>
  <td style={{ 
    fontWeight: 500,
    textAlign: isRTL ? "right" : "left",
    direction: "ltr", 
    unicodeBidi: "plaintext" 
  }}>
    <span className="badge" style={{
      color: statusStyles[talent.status]?.color || "#959595",
      backgroundColor: statusStyles[talent.status]?.bg || "#FDE3E3",
    }}>
      {talent?.status ? talent.status : "-"}
    </span>
  </td>
  <td style={{
    color: "#959595",
    maxWidth: "150px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    direction: "ltr",
    unicodeBidi: "plaintext"
  }}>
    {talent?.project_id?.title
      ? talent.project_id.title.split(" ").slice(0, 3).join(" ") +
        (talent.project_id.title.split(" ").length > 3 ? "..." : "")
      : ""}
  </td>
  <td style={{ 
    color: "#959595", 
    direction: "ltr", 
    unicodeBidi: "plaintext" 
  }}>
    {talent.total_amount} AED
  </td>
</tr>
                    )
                  }))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Pagination */}
        {pagination?.total_pages > 1 && (
                <Paginator
                    page={pagination.current_page}
                    rows={pagination.per_page}
                    totalRecords={pagination.total_records}
                    onPageChange={handlePageChange}
                />
            )}
      </div>

      {/* Footer */}
      {/* <div>
        <footer
          className="inter-font d-flex justify-content-between align-items-center text-muted"
          style={{
            background: "#7B6E43",
            width: "81.8%",
            height: "55px",
            paddingLeft: "35px",
            position: "absolute",
            bottom: "0px",
          }}
        >
          <div className="inter-font text-white ms-3">
            @2025 Nahham, All rights reserved.
          </div>
          <div className="inter-font text-white">
            Privacy Policy | Terms and Conditions
          </div>
          <div className="inter-font social-icons-dashboard d-flex justify-content-center align-items-center">
            <img src={fb} />
            <img src={x} />
            <img src={instagram} />
            <img src={linkedIn} />
            <img src={yt} />
            <img src={tiktok} />
            <img src={snapchat} className="inter-font me-5" />
          </div>
        </footer>
      </div> */}
    </div>
  );
};

export default Dashboard;
